const TRUE_VALUES = new Set(["1", "true", "yes", "on"]);

export const isLocalTestnetMetaMaskEnabled = () => {
  if (typeof window !== "undefined" && window.__E2E_WALLET__) {
    return true;
  }
  return TRUE_VALUES.has(
    String(process.env.VUE_APP_LOCAL_TESTNET_METAMASK || "").toLowerCase()
  );
};
